	const period = [
		{ value: "Day" },
		{ value: "Month" },
		{ value: "Year" },
	];

	const amenities = [
		{ value: "Furnished" },
		{ value: "Pet Allowed" },
		{ value: "Shared Accomodation" },
	];

	const nums = [
		{ value: 1 },
		{ value: 2 },
		{ value: 3 },
		{ value: 4 },
		{ value: 5 },
	];

export {period, amenities, nums}